import { useMemo } from 'react';
import { FeatureReadinessNameUseSchedulerV3 } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/feature_readiness.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';

export const useGetWSMActiveLocationIds = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { getCustomizationFlagLocationMap } = useAppFlagStore();

  const wsmActiveLocationIds = Object.entries(
    getCustomizationFlagLocationMap({ locationIds: selectedLocationIds, flagName: 'weaveschedulemanagement' })
  )
    .filter(([, flag]) => flag?.state === 'ACTIVE')
    .map(([locationId]) => locationId);

  return { wsmActiveLocationIds };
};

export const useGetSchedulerV3FeatureFlagDetails = () => {
  const { selectedOrgId, selectedGroupId } = useAppScopeStore();

  const { data, isLoading: isLoadingFeatureReadiness } = SchedulerV3.Queries.useListLocationGroupFeatureReadinessQuery({
    request: {
      orgId: selectedOrgId,
      parentLocationId: selectedGroupId,
      names: [FeatureReadinessNameUseSchedulerV3],
    },
  });

  const isV3Enabled = useMemo(() => {
    const newScheduleV3FF =
      data?.features?.find((feature) => feature.name === FeatureReadinessNameUseSchedulerV3)?.enabled ?? false;

    return newScheduleV3FF;
  }, [data?.features]);

  const isLoading = isLoadingFeatureReadiness;

  return {
    isScheduleV3FlagEnabled: isLoading ? false : isV3Enabled,
    isSchedulerV2FlagEnabled: isLoading ? false : !isV3Enabled,
    isLoading,
  };
};
